import * as React from "react";
import { DM_DataSheet } from "../models/DM_DataSheet";
import { ClickedDeviceInfo } from "../models/clickedDeviceInfo";

interface Props {
  ulClassName: string;
  title: string;
  searchPattern: string;
}
interface State {
  expanded: boolean;
}

const liStyle: React.CSSProperties = {
  cursor: "pointer",
  color: "black"
};

export class ExpandedListItem extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  renderList() {
    return <ul className={this.props.ulClassName} style={{ overflow: "hidden" }}>
      {this.props.children}
    </ul>
  }

  onClick() {
    if (this.props.searchPattern) {
      return;
    }
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    return (
      <div>
        <li id={this.props.ulClassName.toUpperCase()} onClick={() => this.onClick()}>{this.props.title}</li>
        {(this.props.searchPattern || this.state.expanded) && this.renderList()}
      </div>
    );
  }
}